import React, { useState, useRef, useEffect } from 'react'

export default function RotatePopover({ canvas, selectedObject, onChange }) {
  const [open, setOpen] = useState(false)
  const popoverRef = useRef(null)

  useEffect(() => {
    if (!open) return
    const handleClickOutside = (e) => {
      if (popoverRef.current && !popoverRef.current.contains(e.target)) setOpen(false)
    }
    const handleEscape = (e) => { if (e.key === 'Escape') setOpen(false) }
    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleEscape)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleEscape)
    }
  }, [open])

  useEffect(() => { setOpen(false) }, [selectedObject])

  const rotate = (delta) => {
    if (!selectedObject || !canvas) return
    const newAngle = (selectedObject.angle + delta + 360) % 360
    canvas.fire('before:transform', { transform: { target: selectedObject } })
    selectedObject.rotate(newAngle)
    selectedObject.setCoords()
    canvas.fire('object:modified', { target: selectedObject })
    canvas.requestRenderAll()
    onChange?.()
    setOpen(false)
  }

  return (
    <div className="selection-toolbar__popover-anchor" ref={popoverRef}>
      <button
        className={`selection-toolbar__btn${open ? ' selection-toolbar__btn--active' : ''}`}
        onClick={() => setOpen(!open)}
        title="Rotate"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21.5 2v6h-6" />
          <path d="M21.34 15.57a10 10 0 11-.57-8.38L21.5 8" />
        </svg>
        Rotate
      </button>

      {open && (
        <div className="selection-toolbar__popover selection-toolbar__popover--rotate">
          <p className="selection-toolbar__popover-hint">
            Drag the blue handle on the artwork for any angle.
          </p>
          <button className="selection-toolbar__popover-btn" onClick={() => rotate(90)}>90° CW</button>
          <button className="selection-toolbar__popover-btn" onClick={() => rotate(-90)}>90° CCW</button>
          <button className="selection-toolbar__popover-btn" onClick={() => rotate(180)}>180°</button>
        </div>
      )}
    </div>
  )
}
